import { useNavigate } from "react-router-dom";
import tokenUtils from "../../utils/tokenUtils";
import routes from "../../constants/routes";
import PrimaryButton from "../../widgets/Buttons/PrimaryButton";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    if (tokenUtils.isLoggedIn()) {
      navigate(routes.home.root, { replace: true });
    } else {
      navigate(routes.login.root, { replace: true });
    }
  };

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2>404 - Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
      <PrimaryButton onClick={handleRedirect} sx={{ mt: 2, maxWidth: "200px" }}>
        {tokenUtils.isLoggedIn() ? "Go to Home" : "Go to Login"}
      </PrimaryButton>
    </div>
  );
};

export default NotFoundPage;
